import * as deviceService from 'services/device-service';
import * as logger from 'logger';
import * as tenantApi from 'api/tenant-api';
import {
  BeginRegisterDeviceAction,
  GetTenantErrorAction,
  REGISTER_DEVICE,
  RegisterDeviceAction,
  GENERATE_DEVICE_ID
  } from './actions';
import { Dispatch, Middleware, MiddlewareAPI } from 'redux';
import { getI18n } from 'services/i18n-service';
import * as tenantService from 'services/tenant-service';
import { translations } from 'types/translations';
import { SetDeviceIdAction } from 'pages/device-info/actions';

const i18n = getI18n();

const DeviceRegistrationMiddleware: Middleware = store => next => async action => {

  try {
    switch (action.type) {

      case GENERATE_DEVICE_ID:
        await generateDeviceId(store);
        break;

      case REGISTER_DEVICE:
        await registerDevice(next, store, action);
        break;

      default:
        break;
    }

    next(JSON.parse(JSON.stringify(action)));
  }
  catch (e) {
    const error = e as Error;
    logger.error(error, 'DeviceRegistrationMiddleware');
  }
};

async function registerDevice(next: Dispatch, store: MiddlewareAPI, action: RegisterDeviceAction) {
  try {
    store.dispatch(new BeginRegisterDeviceAction());
    let deviceId = await deviceService.getDeviceId();
    const tenant = await tenantApi.registerDevice(action.tenantId, deviceId);
    if (tenant === null) {
      next(new GetTenantErrorAction(i18n.t(translations.TenantDoesNotExist) + action.tenantId));
    } else {
      await tenantService.saveTenant(tenant);
      location.reload(true);
    }
  }
  catch (e) {
    const error = e as Error;
    let errorMessage = error.message;
    if (errorMessage === null) {
      errorMessage = i18n.t(translations.UnknownErrorOccurred, { function: 'registerDevice' });
    }
    next(new GetTenantErrorAction(errorMessage));
  }
}

async function generateDeviceId(store: MiddlewareAPI) {
  const deviceId = await deviceService.generateDeviceId();
  store.dispatch(new SetDeviceIdAction(deviceId));
}

export default DeviceRegistrationMiddleware;



// WEBPACK FOOTER //
// ./src/pages/device-registration/middleware.ts